import { Injectable } from '@angular/core'
import { OcorrenciaModel, ProcessamentoOcorrenciaModel, TipoOcorrenciaEnum } from '@shared/models/backend'

@Injectable({
  providedIn: 'root',
})
export class RegistroService {
  getTitle(registro: ProcessamentoOcorrenciaModel) {
    switch (registro?.ocorrencia?.tipoOcorrencia?.id) {
      case TipoOcorrenciaEnum.FALTA_MUDANCA_SITUACAO:
      case TipoOcorrenciaEnum.SUSPENSO_MUDANCA_SITUACAO:
        return registro?.ocorrencia?.situacaoMatricula?.descricao
    }

    return registro?.ocorrencia?.tipoOcorrencia?.descricao
  }

  getRegistroRefText(registro: ProcessamentoOcorrenciaModel) {
    return this.leftPad(registro?.ocorrencia.referencia)
  }

  getOcorrenciaRefText(ocorrencia: OcorrenciaModel) {
    return this.leftPad(ocorrencia?.referencia)
  }

  getFullTitle(registro: ProcessamentoOcorrenciaModel) {
    return `${this.getTitle(registro)} - ref. ${this.getRegistroRefText(registro)}`
  }

  private leftPad(ref: number) {
    const refStr = '' + ref
    return refStr?.padStart(3, '0')
  }
}
